// Inxiz cart page: sticky Checkout bar for screens under 1150 px. The bar (snippets/inxiz-impact-cart-sticky.liquid)
// is shown only while the real Checkout button of the cart form is out of the viewport; body gets bottom padding
// equal to the bar height while it is shown so nothing is covered. Without JS the bar stays hidden.
if (!customElements.get('inxiz-cart-sticky')) {
  customElements.define('inxiz-cart-sticky', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.media = window.matchMedia('(max-width: 1149px)');
      this.buttonVisible = true;
      const target = document.querySelector('form#inxiz-cart-form [name="checkout"], .cart-form [name="checkout"]');
      if (!target || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => { this.buttonVisible = entry.isIntersecting; });
        this.update();
      }, {threshold: 0.4});
      this.observer.observe(target);
      this.media.addEventListener('change', () => this.update(), {signal});
      window.addEventListener('resize', () => { this.padBody(); this.liftWidgets(); }, {signal});
      // widgets mount late: re-check a few times after load
      [1000, 3000, 6000].forEach(ms => setTimeout(() => this.liftWidgets(), ms));
      this.update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      document.body.style.paddingBottom = '';
      document.documentElement.classList.remove('inxiz-cart-sticky-shown');
    }
    update() {
      const show = this.media.matches && !this.buttonVisible;
      this.hidden = !show;
      // html class drives CSS that lifts Shopify Inbox's chat activator (shopify-chat::part(activator)) above the bar
      document.documentElement.classList.toggle('inxiz-cart-sticky-shown', show);
      this.padBody();
      this.liftWidgets();
    }
    padBody() {
      document.body.style.paddingBottom = this.hidden ? '' : `${this.offsetHeight}px`;
    }
    // Third-party bubbles (chat, reviews) sit fixed in the bottom-right corner and would cover the Checkout
    // button: while the bar is shown, lift every fixed top-level element that lives in that corner above it.
    liftWidgets() {
      const lift = this.hidden ? 0 : this.offsetHeight + 8;
      [...document.body.children].forEach(el => {
        if (el === this || el.tagName === 'SCRIPT' || el.tagName === 'STYLE') return;
        const cs = getComputedStyle(el);
        if (cs.position !== 'fixed') return;
        const r = el.getBoundingClientRect();
        if (!r.width || r.width > window.innerWidth * 0.6 || r.height > 200 || r.bottom < window.innerHeight - 160 || r.right < window.innerWidth - 220) return;
        if (!el.dataset.inxizLiftBottom) el.dataset.inxizLiftBottom = cs.bottom;
        el.style.bottom = lift ? `calc(${el.dataset.inxizLiftBottom} + ${lift}px)` : el.dataset.inxizLiftBottom;
      });
    }
  });
}
